import React from 'react';

import { Link } from 'react-router-dom';

import ChordChips from './ChordChips/ChordChips';
import SongHeading from './SongHeading';
import { fixUrlTitle } from './helpers';
import Chip from '../../../../components/common/Chip/Chip';
import DifficultyBar from '../../../../components/common/DifficultyBar/DifficultyBar';
import GuitarTabLink from '../../../../components/common/GuitarTabLink';
import { SongType } from '../../../../types';

// The whole middle of the row links to the song. The difficulty bar (left) and
// the tab link (right) sit outside that link so they keep their own actions, and
// both run the full height of the row.
const SongRow = ({
	isGuitarMode,
	onOpenDifficultyFilter,
	song,
}: SongRowTypes) => (
	<div className="bottom-border" style={rowStyle}>
		{isGuitarMode && (
			<DifficultyBar
				difficulty={song.difficulty}
				onClick={onOpenDifficultyFilter}
			/>
		)}

		<Link style={songLinkStyle} to={'/song/' + fixUrlTitle(song.title)}>
			<SongHeading song={song} />

			{isGuitarMode && (
				<>
					{song.strumPattern && (
						<p style={strumpatternStyle}>{song.strumPattern}</p>
					)}
					{(song.barChords || song.capo) && (
						<div style={chipRowStyle}>
							{song.capo && <Chip title={song.capo} />}
							{song.barChords && <Chip title="Bar Chords" />}
						</div>
					)}
					{song.chords.length > 0 && (
						<ChordChips
							artist={song.artist}
							chords={song.chords}
							title={song.title}
						/>
					)}
				</>
			)}
		</Link>

		{isGuitarMode && <GuitarTabLink song={song} />}
	</div>
);

type SongRowTypes = {
	isGuitarMode: boolean;
	onOpenDifficultyFilter: () => void;
	song: SongType;
};

const rowStyle: React.CSSProperties = {
	display: 'flex',
};

// Fills the row between the difficulty bar and the tab link; its own padding
// gives the text spacing (the row itself has none, so the side elements can run
// full height).
const songLinkStyle: React.CSSProperties = {
	color: 'inherit',
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	gap: 5,
	justifyContent: 'center',
	minWidth: 0,
	padding: 10,
	textDecoration: 'none',
};

const strumpatternStyle: React.CSSProperties = {
	fontSize: 14,
	margin: 0,
};

const chipRowStyle: React.CSSProperties = {
	alignItems: 'center',
	display: 'flex',
	gap: 10,
	justifyContent: 'flex-start',
};

export default SongRow;
